import React from 'react';
import classnames from 'classnames';

type Props = {
  children: React.ReactNode;
  classNames?: string;
  id?: string;
};

SubHeader.defaultProps = {
  classNames: '',
  id: '',
};

export function SubHeader({ children, classNames, id }: Props) {
  return (
    <nav
      id={id}
      className={classnames('sub-header hide_on--print', classNames)}
      data-test-id="subheader-container"
    >
      <div className="sub-header__container">{children}</div>
    </nav>
  );
}
